export default "__VITE_ASSET__q2jVFJDH__";